import { useAppSelector } from 'hooks/reduxHooks'
import { EXPERIENCE_ENABLED_REGIONS } from 'takeovers/societeDoublePointsTakeover/constants/societeDoublePointsTakeoverConstants'

// Campaign end date: 5 Jan 2026, 11:59pm AEST (UTC+11)
const EXPERIENCE_DISCOUNT_BANNER_END_DATE_MS = new Date('2026-01-06T00:00:00+11:00').getTime()

/**
 * Hook to determine if the LuxPlus Experience Discount banner should be shown.
 * Checks if user is in an enabled region and within the campaign period (until 5 Jan 2026).
 */
export function useShowExperienceDiscountBanner(): boolean {
  const currentRegionCode = useAppSelector(state => state.geo.currentRegionCode)
  const isExperienceEnabledRegion = EXPERIENCE_ENABLED_REGIONS.has(currentRegionCode)
  return isExperienceEnabledRegion && Date.now() <= EXPERIENCE_DISCOUNT_BANNER_END_DATE_MS
}
